// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"b4f71cf5","368":"7458c6ab","814":"f4f98cf3"}[chunkId] + ".chunk.js";
};